<template>
  <div class="innerItem settingOrder">
    <div v-if="guestType && guestType.length > 0">
      <p class="innerTitle setLabel">
        {{locale.guesttype_setting}}
        <button type="button" class="btn sizeXs btnWhite" @click="onSettingOpen">{{locale.setting}}</button>
      </p>
      <ul>
        <li v-for="(type, index) in guestType"
          :key="type.id"
          :class="{mt5: index > 0}">
          <SetLanguageValue
            :locale="locale"
            :langValue="type.name" />
        </li>
      </ul>
    </div>
    <GuestTypeLayer v-if="settingLayer"
      :lang="lang"
      :locale="locale"
      :guestType="guestType"
      @close="onSettingClose"
      @apply="updateGuestType" />
  </div>
</template>

<script>
import GuestTypeLayer from '@/components/Util/GuestType.vue'
import SetLanguageValue from '@/components/Util/SetLanguageValue'
import UTIL from '@/common/util'

export default {
  name: 'GuestType',
  props: [
    'locale',
    'guestType',
    'lang'
  ],
  components: {
    GuestTypeLayer,
    SetLanguageValue
  },
  data () {
    return {
      layer: false,
      langValue: {},
      settingLayer: false
    }
  },
  methods: {
    setDefaultVal (id) {
      const defaultLang = this.lang.default
      const target = this.guestType.find(x => x.id === id)
      const fillLangs = UTIL.fillLangs(target.name, target.name[defaultLang])
      target.name = fillLangs
    },
    onLanguageLayerOpen (id) {
      this.langValue = this.guestType.find(x => x.id === id).name
      this.layer = true
    },
    onLanguageLayerClose () {
      this.langValue = {}
      this.layer = false
    },
    onSettingOpen () {
      this.settingLayer = true
    },
    onSettingClose () {
      this.settingLayer = false
    },
    updateGuestType (data) {
      this.$store.commit('setting/setGuestType', data)
      this.onSettingClose()
    }
  }
}
</script>
